import React from 'react';
import { socialLinks } from '../constants';

export const Socials: React.FC = () => (
  <div className="header-social">
    {socialLinks.map(({ title, href }) => (
      <a key={href} href={href} target="_blank" rel="noopener noreferrer" aria-label={title}>
        {title}
      </a>
    ))}
  </div>
);
